import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-810344b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "数据报表")
], -1))
const _hoisted_3 = { class: "data-table-fl" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "时间节点"),
  /*#__PURE__*/_createElementVNode("th", null, "门店名称")
], -1))
const _hoisted_5 = { class: "data-table-fr" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }

import { ref, watch } from 'vue'

import { IBusiness } from '@/utils/interface'
import { getBusinessData } from '@/api/shop'


export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: String,
    default() {
      return ''
    }
  },
  timeType: {
    type: Number,
    default() {
      return 0
    }
  },
  shopNo: {
    type: String,
    default() {
      return ''
    }
  }
},
  setup(__props) {

const props = __props



watch([() => props.shopNo, () => props.timeType], () => {
  data.value = []
  curPage.value = 1
  loading.value = true
  finished.value = false
  onLoad()
})

const ths = {
  mealRate: '上座率',
  turnoverRate: '翻台率',
  tableUtilization: '餐位利用率',
  orderTime: '点单时长',
  mealTime: '就餐时长',
  serveTime: '上锅时效',
  cleanTableTime: '清台时效'
}

const loading = ref(false)
const finished = ref(false)
const curPage = ref(1)
const curSize = ref(40)
const data = ref<IBusiness[]>([])
const onLoad = () => {
  setTimeout(() => {
    getBusinessData({
      companyId: '1',
      timeType: props.timeType,
      pageNum: curPage.value,
      pageSize: curSize.value,
      shopNo: props.shopNo
      // shopNo: '050122'
    }).then((res: any) => {
      if (curPage.value === 1) {
        data.value = res.rows
      } else {
        data.value = data.value.concat(res.rows)
      }
      loading.value = false

      if (data.value.length >= res.total) {
        finished.value = true
      } else {
        curPage.value += 1
      }
    })
  }, 500)
}

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_van_list, {
      loading: loading.value,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
      finished: finished.value,
      "finished-text": "没有更多了",
      class: "warning-list",
      offset: "5",
      onLoad: onLoad
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(['data-table', props.type ? 'single-data-table' : ''])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", null, [
              _hoisted_4,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(item.time), 1),
                  _createElementVNode("td", null, _toDisplayString(item.shopName), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(ths), (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (!props.type || (props.type && ths[props.type] === item))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_6, _toDisplayString(item), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(ths), (item2, index2) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index2 }, [
                      (!props.type || (props.type && props.type === item2))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                            _createElementVNode("div", {
                              style: _normalizeStyle({ width: item[item2] })
                            }, null, 4),
                            _createElementVNode("span", null, _toDisplayString(item[item2]), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["loading", "finished"])
  ]))
}
}

})